import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar-rail" }
const _hoisted_2 = { class: "nav-logo" }
const _hoisted_3 = { class: "new-chat" }
const _hoisted_4 = { class: "items" }
const _hoisted_5 = { class: "bottom-bar" }
const _hoisted_6 = { class: "items" }
const _hoisted_7 = { class: "rail-item" }
const _hoisted_8 = { class: "profile" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Logo = _resolveComponent("Logo")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Avatar = _resolveComponent("Avatar")

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Logo, {
        size: "3.2rem",
        type: "big-icon"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Icon, {
        icon: "edit-05",
        size: "1.8rem",
        stroke: "var(--gray-500)",
        "stroke-width": "1.2"
      })
    ]),
    _createVNode(_component_ScrollBar, {
      class: "scroller",
      fade: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
            return (_openBlock(), _createBlock(_component_Tooltip, {
              key: item.title,
              text: item.title,
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["rail-item", {active: $options.isCurrentRoute(item)}])
                }, [
                  _createVNode(_component_Icon, {
                    icon: item.icon,
                    size: "1.8rem",
                    stroke: "var(--gray-500)",
                    "stroke-width": "1.2"
                  }, null, 8 /* PROPS */, ["icon"])
                ], 2 /* CLASS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Divider, {
        m: "0.6rem 1rem",
        bg: "var(--border-primary)"
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Icon, {
            icon: "message-text-square-02",
            size: "1.8rem",
            stroke: "var(--gray-500)",
            "stroke-width": "1.2"
          })
        ]),
        (_ctx.$responsive.desktop)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["rail-item", {active: $options.is_settings}])
            }, [
              _createVNode(_component_Icon, {
                icon: "settings-01",
                size: "1.8rem",
                stroke: "var(--gray-500)",
                "stroke-width": "1.2"
              })
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_Divider, {
        m: "0.8rem 1rem 0",
        bg: "var(--border-primary)"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Avatar, {
          name: $options.profile.display_name,
          image_id: $options.profile.avatar_id,
          width: "3.2rem",
          height: "3.2rem"
        }, null, 8 /* PROPS */, ["name", "image_id"])
      ])
    ])
  ]))
}